import React from 'react'
import { EligibilityRoutes } from '../routing/routes.component'
import { EligibilityDataProvider } from './eligibility-data.provider'

export const EligibilityContainer = () =>
  <EligibilityDataProvider>
    <EligibilityRoutes />
  </EligibilityDataProvider>